import {Injectable} from "@angular/core";
import {Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";
import {AlertService} from '../services';
import {ENVIRONMENT} from "../../environments/environment";
import {HelperService} from "../services/helperService";


/**
 * @desc Wenn config nicht geladen werden kann, zeige Errorseite an, ohne config kann WCMS nicht starten
 */
@Injectable()
export class ConfigGuards implements CanActivate
{


    /**
     * Function > constructor
     * @param {Router} OBJ_router
     * @param {AlertService} OBJ_alert_service
	 * @param {HelperService} OBJ_helper_service
     */
	constructor
	(
		private OBJ_router: Router,
        private OBJ_alert_service: AlertService,
		private OBJ_helper_service: HelperService
    ) {} // end function constructor


	/**
	 * Function > canActivate
	 * @param OBJ_route
	 * @param OBJ_state
	 * @return {boolean}
	 */
	canActivate(OBJ_route: ActivatedRouteSnapshot, OBJ_state: RouterStateSnapshot): boolean
	{
		this.OBJ_helper_service.logWithClassAndFunction("ConfigGuards", "canActivate", OBJ_route, OBJ_state);

		if (this.OBJ_helper_service.getFromLocalstorage('config')) {

			// remove error reason from local storage
            this.OBJ_helper_service.removeFromStorage('error_reason');

			// config in local storage --> return true
			return true;

		} // end if

		// Grund angeben
        localStorage.setItem("error_reason", "oError.sConfig");

		// Interner Fehler
        localStorage.setItem("internal", "1");

        this.OBJ_alert_service.error("oError.sRetry");

		// config not in local storage so redirect to error page
		this.OBJ_router.navigate(["/errorlogin"]);

		return false;

	} // end function canActivate


} // end function ConfigGuards
